










































































































































































































import { emailRule, extendetPhoneRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { deepCopy } from "@/lib/utility/deep-copy";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { AddressEntity } from "@/models/addressEntity";
import { ContactEntity } from "@/models/contactEntity";
import { MrfiktivUpdateUserDtoGen, MrfiktivUserViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EditProfileDialog extends DarkModeHighlightMixin {
  @Prop()
  userToUpdate!: MrfiktivUserViewmodelGen;

  @Prop({ default: false })
  isLoading!: boolean;

  dialog = false;
  valid = false;

  user: MrfiktivUpdateUserDtoGen = {
    firstName: "",
    lastName: "",
    contact: {
      phone: "",
      email: ""
    },
    address: {
      street: "",
      city: "",
      zip: "",
      state: ""
    },
    company: "",
    taxnumber: ""
  };

  emptyContact: ContactEntity = {
    email: "",
    phone: ""
  };

  emptyAddress: AddressEntity = {
    street: "",
    state: "",
    city: "",
    zip: ""
  };

  initialize() {
    this.user = deepCopy(this.userToUpdate);
    if (!this.user?.contact) {
      this.user.contact = this.emptyContact;
    }

    if (!this.user?.contact?.email) {
      this.user.contact.email = "";
    }

    if (!this.user?.contact?.phone) {
      this.user.contact.phone = "";
    }
  }

  mounted() {
    this.initialize();
  }

  async save() {
    this.$emit("updateUser", this.user);
    this.closeDialog();
  }

  closeDialog() {
    this.dialog = false;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(extendetPhoneRule());

    return rules;
  }
}
